import { specialFont } from "../../Infrastructure/Theme/fontFamily"

const courseListingSx = (dashboardState, cardHeight, isCoursePage) => ({
    root: {
        overflow: 'auto',
        pb: 3,
        minHeight: '100vh'
    },

    content: {
        display: 'flex',
        flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row'
        },
        pb: 2,
        gap: 10,

        px: { md: dashboardState ? 0 : 10 },
        py: { md: dashboardState ? 0 : 5 },
        pt: {
            xs: dashboardState ? 2 : 3,
            md: dashboardState ? 2 : 5
        },

        mx: { xs: 1, sm: 1, md: 0, lg: 0, xl: 0 },
        alignItems: { xs: 'center', sm: 'center', md: 'start' }
    },

    courseCardBox: {
        width: { xs: '100%', sm: 'auto' },
        px: 1
    },
    backArrow: {
        cursor: 'pointer',
        display: 'inline-block',
        width: '100%'
    },
    contentBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '30px', sm: '30px', md: '30px' },
        width: dashboardState ? { md: "70%", lg: "70%", xl: "70%" } : '100%',
        minHeight: { md: '80vh' },
        height: { md: cardHeight },
        overflow: {
            md: "scroll",
        },
        mt: dashboardState ? 4 : isCoursePage ? 0 : 0
    },
    objectivesMainBox: {
        pb: 3,
        px: 3,
        width: "100%"
    },
    objectivesTitle: { fontWeight: '700', pb: 3 },
    objectivesSecondMainBox: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 2
    },
    objectivesBox: {
        display: 'flex',
        width: { lg: "48%" },
        alignItems: "start"
    },
    doneIcon: (theme) => ({ color: theme.palette.primary.main, fontSize: 20, marginRight: 1 }),
    objectiveText: {
        fontSize: "15px",
        fontWeight: '400',
        wordBreak: 'break-word'
    },
    // 
    curriculumMainBox: {
        p: 3,
        width: "100%"
    },
    curriculumTitle: { fontFamily: specialFont, fontWeight: '700', pb: 3 },
    curriculumAccordion: {
        wordBreak: "break-word"
    },
    prerequisitesMainBox: { wordBreak: "break-word", p: 3, width: "100%" },
    prerequisitesTitle: { fontFamily: specialFont, fontWeight: '700', pb: 3 },
    descriptionMainBox: { wordBreak: "break-word", fontSize: "15px", p: 3, width: "100%" },
    descriptionTitle: { fontWeight: '700', pb: 3, fontFamily: specialFont },
    intendedLearnerMainBox: { wordBreak: "break-word", p: 3, width: "100%" },
    intendedLearnerTitle: { fontWeight: '700', pb: 3, fontFamily: specialFont },
    cohortBox: {
        mt: dashboardState ? 6 : isCoursePage ? 4.5 : 0,
        pb: 3,
        pl: 3,
        pr: 3,
        width: "100%",
    },
    cohortTitle: { fontWeight: '700', fontFamily: specialFont, pb: 3 },
    cohortClassesList: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        gap: 2
    }
})

export default courseListingSx